var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.171 64.213c1.71 38.88-77.91 95.837-113.573 68.72-35.663-27.118-33.742-69.85-14.687-82.131 19.055-12.282 42.143 12.035 65.045-2.633 22.902-14.667 61.506-22.837 63.215 16.044Z",
    fill: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAE33",
    d: "M48 54.8h83.2V112H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M55.8 54.8H48V112h7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6 69.1a9.1 9.1 0 0 1 3.723 17.406L96.1 99h-13l2.777-12.494A9.1 9.1 0 0 1 89.6 69.1Z",
    fill: "#383F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3 8c15.795 0 28.6 12.805 28.6 28.6v18.2H59.7V36.6C59.7 20.805 72.505 8 88.3 8Zm0 10.4c-11.847 0-21.45 9.603-21.45 21.45V54.8h42.9V39.85c0-11.847-9.603-21.45-21.45-21.45Z",
    fill: "#9FA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2 8c15.795 0 28.6 12.805 28.6 28.6v18.2h-7.15V39.85c0-11.847-9.603-21.45-21.45-21.45s-21.45 9.603-21.45 21.45V54.8H63.6V36.6C63.6 20.805 76.405 8 92.2 8Z",
    fill: "#D3D5E0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117 46)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#36B37E",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.854 8.442a1.59 1.59 0 0 1 2.406 2.075l-.114.132-9.44 9.808a1.591 1.591 0 0 1-2.162.121l-.13-.121L6.49 16.38a1.59 1.59 0 0 1 2.166-2.325l.127.118 2.776 2.884 8.295-8.616Z",
    fill: "#FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLocked);
export default __webpack_public_path__ + "static/media/feature-locked.8952bc2b.svg";
export { ForwardRef as ReactComponent };